import React from 'react';
import cx from "classnames";
import ChannelLink from "../../containers/channelUtils/ChannelLink";
import ChannelImage from "../../containers/channelUtils/ChannelImage";
import Badge from "../badge/Badge";
import {FormattedMessage} from "react-intl";
import Pricing from "../pricing/Pricing";
import Button from "../button/Button";

const ProductItem = ({product, idx, related, mainProduct, taxon, onRelatedProductSelect, onProductSelect}) => {
  return (
    <span
      key={product.id}
      onClick={
       related
         ? () => onRelatedProductSelect(product, mainProduct, idx)
       : () => onProductSelect(taxon, product, idx)
     }
      className={cx('product', 'product--dimmed', !product.inStock && 'product--out-of-stock')}
      >
        <ChannelLink to={`/service/${product.slug}`} className="product__link">
          <div className="product__image">
            <ChannelImage
              src={!!product.images.length && product.images[0]}
                width={540}
                height={340}
                alt={product.name}
                loading="lazy"
              />
              {product.labels.length > 0 && <Badge type={product.labels[0].label}/>}
              </div>

            <div className="product__header">{product.name}</div>

            <div className="product__bottom">
              {product.isConfigurable && (
                <p className="product__starts">
                  <FormattedMessage id="section.products.starts"/>
                </p>
              )}

              <div className="product__action">
                <p className="product__price">
                  <Pricing value={product.price} originalValue={product.originalPrice}/>
                </p>

                  <div className="product__btn">
                    <Button
                      iconed
                      small
                      mod="details"
                      aria-hidden="true"
                      tabIndex="-1"
                    >
                      <span className='product__btn-icon'></span>
                    </Button>
                  </div>
                </div>
              </div>
            </ChannelLink>
          </span>
    );
};

export default ProductItem;


// WEBPACK FOOTER //
// ./components/products/ProductItem.js